import { Link } from 'react-router-dom';
import { Check, ArrowRight, Info } from 'lucide-react';
import PageHero from '../../components/public/PageHero';
import Reveal from '../../components/public/Reveal';
import { MEMBERSHIP_PLANS } from '../../lib/constants';

export default function Membresias() {
  return (
    <div>
      <PageHero
        eyebrow="Membresías"
        title="Elige la categoría que se ajusta a tu perfil"
        description="Cada categoría habilita servicios y beneficios dentro del ecosistema CNIB Connect."
      />

      <section className="py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-3">
            {MEMBERSHIP_PLANS.map((plan, i) => (
              <Reveal key={plan.name} delay={i * 0.1}>
                <div
                  data-testid={`membership-plan-${i}`}
                  className={`relative flex h-full flex-col rounded-3xl p-8 transition-all duration-300 hover:-translate-y-1 ${
                    plan.featured
                      ? 'bg-cnib-navy shadow-2xl shadow-cnib-navy/30'
                      : 'border border-slate-100 bg-white shadow-sm hover:shadow-xl'
                  }`}
                >
                  {plan.featured && (
                    <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 rounded-full bg-orange-500 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white">
                      Más elegida
                    </span>
                  )}
                  <h3 className={`font-heading text-2xl font-bold ${plan.featured ? 'text-white' : 'text-slate-900'}`}>
                    {plan.name}
                  </h3>
                  <p className={`mt-1 text-sm ${plan.featured ? 'text-slate-300' : 'text-slate-500'}`}>{plan.tagline}</p>
                  <ul className="mt-8 flex-1 space-y-3.5">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-start gap-3">
                        <span
                          className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                            plan.featured ? 'bg-orange-500' : 'bg-cnib-blue/10'
                          }`}
                        >
                          <Check className={`h-3 w-3 ${plan.featured ? 'text-white' : 'text-cnib-blue'}`} />
                        </span>
                        <span className={`text-sm ${plan.featured ? 'text-slate-200' : 'text-slate-600'}`}>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/hagase-socio"
                    data-testid={`membership-plan-cta-${i}`}
                    className={`group mt-8 flex items-center justify-center gap-2 rounded-full py-3.5 font-bold transition-all duration-300 ${
                      plan.featured
                        ? 'bg-orange-500 text-white hover:bg-orange-600'
                        : 'border-2 border-cnib-blue text-cnib-blue hover:bg-cnib-blue hover:text-white'
                    }`}
                  >
                    Solicitar afiliación
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-12 flex items-start gap-4 rounded-2xl border border-cnib-blue/15 bg-cnib-blue/5 p-6">
              <Info className="mt-0.5 h-5 w-5 shrink-0 text-cnib-blue" />
              <p className="text-sm leading-relaxed text-slate-600">
                Las cuotas de afiliación se definen según la categoría y la cámara departamental correspondiente, y se
                confirman durante el proceso de revisión de tu solicitud. Un asesor de la CNIB te contactará con el
                detalle exacto antes de cualquier pago.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
